import React, { useMemo } from 'react';

import { CustomFilterPopover } from '@vlabs/shared/components/filters-panel/components/CustomFilterPopover';
import { Divider } from '@vlabs/uikit';
import { Radio } from '@vlabs/uikit/components/controls/radio';
import imageSampleBody from '@vlapps/point/src/images/Select-Image-Body.png';
import imageSampleFace from '@vlapps/point/src/images/Select-Image-Face.png';
import { useTranslation } from 'react-i18next';

import st from './EventSampleSettingsPopover.module.sass';
import { useEventInfoSettingsLocation } from '../../useEventInfoSettingsSearchParams';
import type { MainSample, SampleType } from '../../useEventInfoSettingsSearchParams';
import { SelectImage } from './select-image/SelectImage';

export function EventSampleSettingsPopover(): React.JSX.Element {
  const { t } = useTranslation();
  const { eventInfoSettings: { sampleType, mainSample }, setEventInfoSetting } = useEventInfoSettingsLocation();

  const selectImageOptions = useMemo(() => [
    { id: 'face', imageUrl: imageSampleFace, alt: t('lunapoint:настройки.select image.alt.face') },
    { id: 'body', imageUrl: imageSampleBody, alt: t('lunapoint:настройки.select image.alt.body') },
  ], [t]);

  const changeSampleType = (value: SampleType) => () => {
    setEventInfoSetting('sampleType', value);
  };

  const changeMainSample = (value: MainSample) => {
    setEventInfoSetting('mainSample', value);
  };

  return (
    <CustomFilterPopover
      placementProp="right-start"
      testId="eventSampleSettings"
      triggerValue={t('lunapoint:настройки.настройки отображения лиц и тел')}
    >
      <label className="Subtitle-2">
        {t('lunapoint:настройки.показывать в событиях')}
      </label>
      <Divider small />

      <Radio
        checked={sampleType === 'multi'}
        id="multi"
        label={t('lunapoint:настройки.sample type.multi')}
        onChange={changeSampleType('multi')}
      />
      <Divider small />

      <Radio
        checked={sampleType === 'face'}
        id="face"
        label={t('lunapoint:настройки.sample type.face')}
        onChange={changeSampleType('face')}

      />
      <Divider small />

      <Radio
        checked={sampleType === 'body'}
        id="body"
        label={t('lunapoint:настройки.sample type.body')}
        onChange={changeSampleType('body')}
      />
      <Divider small />

      <div className={st.Divider} />
      <Divider small />

      <label className="Subtitle-2">
        {t('lunapoint:настройки.порядок отображения по умолчанию')}
      </label>
      <Divider small />

      <SelectImage
        disabled={sampleType !== 'multi'}
        onChange={changeMainSample}
        options={selectImageOptions}
        value={mainSample}
      />
    </CustomFilterPopover>
  );
}
